module.exports = __webpack_public_path__ + "static/media/adventureLeashIcon.550eec4f.png";